import React, { useEffect, useState } from 'react';
import NavigationButton from '@/features/PortalNavigation/variants/dropdown/NavigationButton/NavigationButton';
import NavigationDropdown from '@/features/PortalNavigation/components/NavigationDropdown/NavigationDropdown';
import { PortalNavigationProps } from '@/features/PortalNavigation/PortalNavigation.interfaces';
import useIsMobile from '@/features/shared/Hooks/useIsMobile';

export const DropdownNavigation = (props: PortalNavigationProps) => {
  const { label } = props;
  const isMobile = useIsMobile();
  const [buttonRef, setButtonRef] = useState<HTMLElement | null>(null);

  const onButtonClick = (event: any) => {
    setButtonRef((prev) => (prev ? null : event.currentTarget));
  };

  useEffect(() => {
    const closeNavigation = () => {
      setButtonRef(null);
    };
    window.removeEventListener('resize', closeNavigation);
    if (!isMobile) {
      window.addEventListener('resize', closeNavigation);
    }
    return () => window.removeEventListener('resize', closeNavigation);
  }, [isMobile]);

  return (
    <>
      <NavigationButton onClick={onButtonClick} isOpened={!!buttonRef}>
        {label}
      </NavigationButton>
      <NavigationDropdown
        {...props}
        triggerButtonRef={buttonRef}
        onMenuClose={() => setButtonRef(null)}
        onNavItemClick={() => setButtonRef(null)}
      />
    </>
  );
};
